import { render } from "./EditSite.vue?vue&type=template&id=31974e9c&ts=true"
import script from "./EditSite.vue?vue&type=script&lang=ts"
export * from "./EditSite.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__